import React, { useContext, useEffect } from "react";
import { useState, createContext } from "react";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";

const Login = () => {
  const { apiURL, handleUpdateLogin } = useContext(ConfigContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setErrorMessage("");
  }, [username, password]);

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleRememberMeChange = (event) => {
    setRememberMe(event.target.checked);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    

    try {
      const response = await axios.post(`${apiURL}User/Login?login_id=${username}&login_password=${password}`, )
      setIsLoading(false);

      const data = response.data;
      // console.log("Login",data);
      if (data.success) {
        handleUpdateLogin(response.data.data);
        setUsername("");
        setPassword("");
        console.log("data?.induction_status",data?.data?.induction_status)
        if(data?.data?.induction_status==="0"){
          localStorage.setItem("induction_status",data?.data?.induction_status);
        }
        else{
          localStorage.removeItem("induction_status");
        }
        const now = Date.now();
        localStorage.setItem('lastActive_emp', now);
        sessionStorage.setItem('session_active_emp', 'true');
        localStorage.removeItem("reset_emp");
        window.location.href = '/';
        // navigate('/');
      } else {
        setErrorMessage( data?.message || "Invalid username or password");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error during login:====>", error);
      setErrorMessage("Something went wrong. Please try again later.");
      setIsLoading(false);
      
    }
  };

  return (
    <>
      <div className="auth-page-wrapper ">

        <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
          <div className="bg-overlay "></div>

          <div className="shape">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 1440 120"
            >
              <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
            </svg>
          </div>
        </div>
      </div>

      <div className="auth-page-content">
        <div style={{ height: "89vh"}} className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mb-4 text-white">
                <div className="d-inline-block auth-logo">
                  <a href="index.html">

                    <img src="" alt="" height="80" />
                  </a>
                </div>
                <p className="mt-3 fs-15 fw-bolder">Employee Panel</p>
              </div>
            </div>
          </div>


          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-3">
                <div className="card-body rounded-3 position-absolute w-100 bg-white z-1  p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Welcome Back !</h5>
                    <p className="text-muted">
                      Login to continue
                    </p>
                  </div>

                  <div className="p-2 mt-2">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label">
                          Username
                        </label>

                        <input
                          type="text"
                          className="form-control position-relative z-1"
                          id="username"
                          name="username"
                          placeholder="Enter username"
                          value={username}
                          onChange={handleUsernameChange}
                          autoComplete="off"
                        />
                      </div>
                      <div className="mb-3">
                        <div className="float-end">
                          <NavLink
                            to={`/ForgotPassword?user=${username}`}
                            className="text-muted"
                          >
                            Forgot password?
                          </NavLink>
                        </div>
                        <label className="form-label" htmlFor="password-input">
                          Password
                        </label>

                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type={`${showPassword ? 'text' : 'password'}`}
                            className="form-control pe-5 password-input"
                            placeholder="Enter password"
                            id="password-input"
                            value={password}
                            onChange={handlePasswordChange}
                            autoComplete="off"
                          />
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button"
                            id="password-addon"
                            onClick={togglePassword}
                          >
                            <i className={`${showPassword ? 'las la-eye align-middle' : 'las la-eye-slash align-middle'}`}></i>
                          </button>
                        </div>
                      </div>
                      {/* <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="auth-remember-check"
                          checked={rememberMe}
                          onChange={handleRememberMeChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="auth-remember-check"
                        >
                          Remember me
                        </label>
                      </div> */}
                      <div className="mt-4">
                        <button className="btn btn-secondary w-100" type="submit" disabled={!username || !password || isLoading ? true : false}>

                          {isLoading ? 'Please Wait...' : 'Login'}</button>

                      </div>
                      {errorMessage && (
                        <p className="alert alert-danger mt-2 py-2 px-4">{errorMessage}</p>
                      )}
                      {/* <div className="mt-4 text-center"></div> */}
                    </form>
                  </div>
                </div>

                
              </div>
              

              {/* <div className="mt-4 text-center">
                <p className="mb-0">
                  Don't have an account ?
                  <a
                    
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    
                    Signup
                  </a>
                </p>
              </div> */}
            </div>
          </div>

        </div>
      </div>
      
      <footer style={{padding: "20px calc(1.5rem* .5)"}} className="">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">
                  &copy;
                  Employee Panel. Developed by
                  TalentCo IT
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
    </>
  );
};

export default withRouter(Login);
